import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ess-row',
    templateUrl: './row.html',
    styleUrls: ['./row.scss']
})
export class SmartRow {

    /**
     * If true, this row can be expanded to show more contents.
     */
    @Input('expandable')
    expandable: boolean;

    /**
     * If true, all contents are shown; otherwise the row is collapsed.
     * <br>
     * This can be used to create an accordion effect.
     */
    @Input('expanded')
    expanded: boolean;

    /**
     * Event fired when the row is expanded.
     */
    @Output('onExpand')
    onExpand: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
     * Event fired when the row is collapsed.
     */
    @Output('onCollapse')
    onCollapse: EventEmitter<boolean> = new EventEmitter<boolean>();

    toggleExpanded() {
        this.expanded = this.expanded? null : true;
        if (this.expanded) {
            this.onExpand.emit(true);
        } else {
            this.onCollapse.emit(false);
        }
    }
}